<template>
  <footer class="footer fixed">
    <div class="container">
      สงวนสิทธิ์โดย บริษัท ไทยประกันชีวิต จำกัด (มหาชน)
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>
